import { FormResponse } from '../components/FormsV2/formsTypes';
import { EVENTS } from '../constants/webSocketConsts/events';
import { formsApi } from '../services/api/formsApi';

/**
 * This function is responsible of handling the websocket
 * events cache updates for the forms responses.
 * The updateQueryData method is used to apply the changes
 * to the forms responses cache state.
 * @param event - web socket event name
 * @param items - web socket items
 * @returns void
 */
export const FormsV2ResponseHandler = (event: string, items: FormResponse[]) =>
  formsApi.util.updateQueryData('getFormResponses', undefined, draft => {
    const [upcomingFormResponseItem] = items;
    // find the index of the form response object to update/delete/insert.
    const upcomingFormResponseItemIndex = draft.findIndex(
      formResponse => formResponse.ref === upcomingFormResponseItem.ref,
    );

    switch (event) {
      case EVENTS.INSERT:
        // if the form response already exists, do not add it to the forms responses state
        if (upcomingFormResponseItemIndex !== -1) {
          return;
        }
        // add the form response to the forms responses state
        draft.unshift(upcomingFormResponseItem);
        break;
      case EVENTS.REMOVE:
        draft.splice(upcomingFormResponseItemIndex, 1);
        break;
      case EVENTS.MODIFY:
        // update the forms responses cache with the upcoming form response.
        draft.splice(
          0,
          draft.length,
          ...draft.map(formResponse => {
            if (formResponse.ref === upcomingFormResponseItem.ref) {
              return upcomingFormResponseItem;
            }
            return formResponse;
          }),
        );
        break;
      default:
        break;
    }
  });
